import { SOUNDCLOUD_ERROR_CODES } from 'fym-shared/src/music24/songPublish';
import type { SoundCloudConnectResult } from '../../../music24/soundcloud/soundCloudConnectResult';

/**
 * The error states of the return page (design b4-b6). `stateInvalid`: the sign-in link ended (b4).
 * `refused`: SoundCloud or MusicAPI did not finish the sign-in, a 400 with no code (b5).
 * `loginInUse`: another Music24 artist holds this SoundCloud login (b6 line). `failed`: anything else (b6).
 */
export type SoundCloudReturnError = Exclude<SoundCloudConnectResult, 'connected'>;

export function soundCloudReturnError(error: unknown): SoundCloudReturnError {
  const record = error as { m24Limit?: { code?: unknown }; statusCode?: unknown } | null;
  const code = record?.m24Limit?.code;
  if (code === SOUNDCLOUD_ERROR_CODES.connectStateInvalid) {
    return 'stateInvalid';
  }
  if (code === SOUNDCLOUD_ERROR_CODES.loginInUse) {
    return 'loginInUse';
  }
  return record?.statusCode === 400 ? 'refused' : 'failed';
}
